export interface Performance {
  id: string
  url: string
  day: string
  month: string
  monthLong: string
  year: number
  weekday: string
  time: string
  note?: string
  label: string
}

const COUNT_WORDS = ['Geen', 'Eén', 'Twee', 'Drie', 'Vier', 'Vijf', 'Zes', 'Zeven', 'Acht', 'Negen', 'Tien']

const capitalize = (value: string) => value.charAt(0).toUpperCase() + value.slice(1)

// Storyblok Event stories (content.date like "2027-01-29 20:00", content.url) → upcoming performances in date order
export const usePerformances = (stories: Array<any> = []) => {
  const now = Date.now()
  const events = stories
    .map(story => ({ story, date: new Date(String(story.content?.date ?? '').replace(' ', 'T')) }))
    .filter(({ date }) => !Number.isNaN(date.getTime()) && date.getTime() > now - 12 * 60 * 60 * 1000)
    .sort((a, b) => a.date.getTime() - b.date.getTime())

  const performances: Array<Performance> = events.map(({ story, date }, index) => {
    const weekday = capitalize(date.toLocaleDateString('nl-NL', { weekday: 'long' }))
    const monthLong = date.toLocaleDateString('nl-NL', { month: 'long' })
    const time = date.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' })
    let note: string | undefined
    if (index === 0) {
      note = 'Première'
    } else if (index === events.length - 1) {
      note = 'Laatste voorstelling'
    } else if (date.getHours() < 17) {
      note = 'Middagvoorstelling'
    }
    const day = String(date.getDate())
    return {
      id: story.uuid,
      url: story.content?.url?.url || story.content?.url?.cached_url || '/kaartverkoop',
      day,
      month: date.toLocaleDateString('nl-NL', { month: 'short' }).replace('.', ''),
      monthLong,
      year: date.getFullYear(),
      weekday,
      time,
      note,
      label: `Kaarten voor ${note ? `de ${note.toLowerCase()} op ` : ''}${weekday.toLowerCase()} ${day} ${monthLong} ${date.getFullYear()} om ${time}`
    }
  })

  const first = performances[0]
  const last = performances[performances.length - 1]
  const when = first && last ? `${first.day} ${first.month} – ${last.day} ${last.month} ${last.year}` : ''
  const whenLong = first && last ? `${first.day} ${first.monthLong} t/m ${last.day} ${last.monthLong} ${last.year}` : ''
  const count = COUNT_WORDS[performances.length] ?? String(performances.length)
  const where = performances.length ? `${count} ${performances.length === 1 ? 'voorstelling' : 'voorstellingen'} in Schouwburg Hengelo` : 'Schouwburg Hengelo'

  return { performances, when, whenLong, where, year: first?.year ?? new Date().getFullYear() }
}
